import { Center, Image } from '@mantine/core'

import CAMERA from '#assets/images/templates/camera.png'
import GAME from '#assets/images/templates/game.png'
import TV from '#assets/images/templates/tv.png'
import { extractFaIconInfo, SmartFaIcon } from '#components/FaIcon'
import { isTemplateImageAsset } from '#components/Staff/Templates/types'

import styles from './TemplateImage.module.scss'

// DO NOT CHANGE THESE NAMES!! They are referenced in the database
// as identifiers for template images
const TEMPLATE_IMAGE_PNG = {
  CAMERA,
  GAME,
  TV,
}

type Props = {
  icon?: string
}

export const TemplateImage = ({ icon }: Props) => {
  const isFaIcon = !!extractFaIconInfo(icon).iconName

  if (isFaIcon) {
    return (
      <Center className={styles.templateImage}>
        <SmartFaIcon className={styles.faIcon} icon={icon} />
      </Center>
    )
  }

  // use the TV as a fallback in case of bad data
  const imgSrc =
    icon && isTemplateImageAsset(icon)
      ? TEMPLATE_IMAGE_PNG[icon]
      : TEMPLATE_IMAGE_PNG.TV

  return <Image className={styles.templateImage} src={imgSrc} />
}
